module.exports = __webpack_public_path__ + "static/media/HomeIconBlue.a381fc01.png";